import FastImage from 'react-native-fast-image';
import ModernSpinner from '~components/ModernSpinner';
import styles from './styles';

const LoadingComponent = () => (
  <FastImage source={require('~assets/images/mainSplashImage.jpg')} style={styles.container}>
    <ModernSpinner size={60} variant="gradient" />
  </FastImage>
);

export default LoadingComponent;
